import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import DriverGraph from "components/RunPlot/DriverGraph";

class DriverGraphContainer extends React.PureComponent {
  render() {
    const { model, getModelFeature } = this.props;

    const featureBars =
      model && model.featureInfo && model.featureInfo.length > 0
        ? model.featureInfo.map((f) => ({
            left: f.score,
            label: f.label,
            leftModel: model.id,
            values: getModelFeature(model.id, f.label).values
          }))
        : [];

    return <DriverGraph {...this.props} featureBars={featureBars} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getModelFeature: (modelId, feature) =>
      dispatch(runReducer.getModelFeatureInfoWithDispatch(ownProps.id, modelId, feature))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DriverGraphContainer);
